import { AltiusRes, IAssetClass } from "store/types";

import { DealAction } from "../actions";
import { AsyncActions, AsyncActionsParams } from "../base";

export interface IAssetClassesActions {
  // if no "parent_id" return all asset classes and join sub-asset classes
  // if parent_id = integer, return an array of where should be asset classes where "parent_id"...
  // if parent_id = null, return all parent asset classes without joining sub-asset classes.
  // if parent_id = true, return all "sub-asset" classes where parent_id is integer (true).
  getAssetClassesAction: () => Promise<IAssetClass[]>;
  getAssetClassesManagementAction: () => Promise<IAssetClass[]>;
  getAssetClassesPrivateIndexesAction: () => Promise<{ id: number; name: string }[]>;
  createAssetClassesAction: (data: { name: string; parent_id?: number }) => Promise<IAssetClass>;
  createAssetClassManagementAction: (data: {
    name: string;
    is_hidden: boolean;
    sub_asset_classes: Array<{
      name: string;
      is_hidden: boolean;
    }>;
  }) => Promise<IAssetClass>;
  updateAssetClassAccountDataAction: (
    data: Pick<IAssetClass, "id"> &
      Partial<Pick<IAssetClass, "name" | "is_hidden" | "public_index" | "expected_return" | "private_index">>
  ) => Promise<IAssetClass>;
  setVisibilitySubAssetClassesAction: (data: { asset_classes_ids: number[]; is_hidden: boolean }) => Promise<void>;
  deleteAssetClassesAction: (id: number) => Promise<void>;
}

export class AssetClassesActions extends AsyncActions implements IAssetClassesActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public getAssetClassesAction: IAssetClassesActions["getAssetClassesAction"] = async () => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<IAssetClass[]>>({
      url: "/api/v0.0.3/asset-classes"
    });
    this.dispatch({ type: DealAction.GetAssetClassesSuccess, payload });
    return payload;
  };

  public getAssetClassesManagementAction: IAssetClassesActions["getAssetClassesManagementAction"] = async () => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<IAssetClass[]>>({
      url: "/api/v0.0.3/asset-classes-management"
    });
    return payload;
  };

  public getAssetClassesPrivateIndexesAction: IAssetClassesActions["getAssetClassesPrivateIndexesAction"] =
    async () => {
      const {
        data: { data: payload }
      } = await this.api.get<AltiusRes<IAssetClass[]>>({
        url: "/api/v0.0.3/asset-classes-management/private-indexes"
      });
      return payload;
    };

  public createAssetClassesAction: IAssetClassesActions["createAssetClassesAction"] = async (data) => {
    const {
      data: { data: payload }
    } = await this.api.post<AltiusRes<IAssetClass>>({
      url: "/api/v0.0.3/asset-classes",
      data
    });
    return payload;
  };

  public createAssetClassManagementAction: IAssetClassesActions["createAssetClassManagementAction"] = async (data) => {
    const {
      data: { data: payload }
    } = await this.api.post<AltiusRes<IAssetClass>>({
      url: "/api/v0.0.3/asset-classes-management",
      data
    });
    return payload;
  };

  public updateAssetClassAccountDataAction: IAssetClassesActions["updateAssetClassAccountDataAction"] = async ({
    id,
    ...body
  }) => {
    const {
      data: { data }
    } = await this.api.patch<AltiusRes<IAssetClass>>({
      url: `/api/v0.0.3/asset-classes-management/${id}/account-data`,
      data: body
    });
    return data;
  };

  public setVisibilitySubAssetClassesAction: IAssetClassesActions["setVisibilitySubAssetClassesAction"] = async (
    body
  ) => {
    await this.api.patch<AltiusRes<IAssetClass>>({
      url: "/api/v0.0.3/asset-classes-management/sub-asset-classes-visibility",
      data: body
    });
  };

  public deleteAssetClassesAction: IAssetClassesActions["deleteAssetClassesAction"] = async (id) => {
    await this.api.delete<AltiusRes<IAssetClass>>({
      url: `/api/v0.0.3/asset-classes-management/${id}`
    });
  };
}
